function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 495 495"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M90.003 267.5v-40H227.5V90.256h20V40C133.08 40 40 133.08 40 247.5S133.08 455 247.5 455V267.5z",
    style: {
      fill: "#9bfbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.538 69.799v74.818h-40v-93.5C293.499 43.915 270.949 40 247.5 40v50.256h20V267.5h-20V455C361.92 455 455 361.92 455 247.5c0-75.287-40.302-141.329-100.462-177.701",
    style: {
      fill: "#46f8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 227.5H90.003v40H267.5V90.256h-40z",
    style: {
      fill: "#003f8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.22 108.38C480.21 149.49 495 197.59 495 247.5c0 66.11-25.74 128.26-72.49 175.01S313.61 495 247.5 495v-40C361.92 455 455 361.92 455 247.5c0-73.78-38.58-140.69-100.46-177.83v74.95h-40V17.37h126.55v40h-35.1c17.58 14.67 33.14 31.79 46.23 51.01",
    style: {
      fill: "#005ece"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.01.69-2.95 39.89c-5.19-.39-10.43-.58-15.56-.58C133.08 40 40 133.08 40 247.5S133.08 455 247.5 455v40c-66.11 0-128.26-25.74-175.01-72.49S0 313.61 0 247.5 25.74 119.24 72.49 72.49 181.39 0 247.5 0c6.12 0 12.34.23 18.51.69",
    style: {
      fill: "#2488ff"
    }
  }));
};
export { SvgDefault as ReactComponent };
export default __webpack_public_path__ + "26af1753fb56bcc89c3665c9d281772f.svg";